module.exports = __webpack_public_path__ + "static/media/sopt19kz.38074be6.pdf";